export default __webpack_public_path__ + "static/media/floorplan2.a1383eb7.jpg";